const SET_USER = "SET_USER";

export const setUser = (payload) => ({
    type: SET_USER,
    payload,
});

const initialState = {
    user: {
        firstName: "sayem",
        lastName: "sam",
        email: "sayem@bs-23.net",
        schema: ["derma", "infocenter"],
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.payload,
                },
            };
        default:
            return state;
    }
};
